"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var profile_1 = require("./profile");
exports.ProfileService = profile_1.ProfileService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/services/index.js
// module id = 437
// module chunks = 0